// extracted by mini-css-extract-plugin
module.exports = {"advisorDetailsPane":"AdvisorDetailsPane__advisorDetailsPane__cDSQe","review":"AdvisorDetailsPane__review__XusBt","stars":"AdvisorDetailsPane__stars__T8+lx"};